import { render, staticRenderFns } from "./userbind.vue?vue&type=template&id=23490a75"
import script from "./userbind.vue?vue&type=script&lang=js"
export * from "./userbind.vue?vue&type=script&lang=js"
import style0 from "./userbind.vue?vue&type=style&index=0&id=23490a75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports